var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.001,
    height: 35,
    viewBox: "0 0 35.001 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-settings",
    "data-name": "Icon ionic-md-settings",
    d: "M34.166,22.625a10.944,10.944,0,0,0,.089-1.75c0-.613-.089-1.137-.089-1.75l3.758-2.887A.8.8,0,0,0,38.1,15.1l-3.58-6.038a.872.872,0,0,0-1.074-.35l-4.475,1.75a13.026,13.026,0,0,0-3.042-1.75l-.627-4.637a.959.959,0,0,0-.9-.7H17.25a.959.959,0,0,0-.895.7L15.64,8.712a15.155,15.155,0,0,0-3.043,1.75L8.122,8.712a.838.838,0,0,0-1.074.35L3.468,15.1a1.057,1.057,0,0,0,.179,1.137L7.5,19.125c0,.613-.089,1.137-.089,1.75s.089,1.137.089,1.75L3.737,25.512a.8.8,0,0,0-.179,1.137l3.58,6.038a.872.872,0,0,0,1.074.35l4.475-1.75a13.024,13.024,0,0,0,3.042,1.75l.716,4.637a.867.867,0,0,0,.895.7H24.5a.959.959,0,0,0,.9-.7l.717-4.637a15.146,15.146,0,0,0,3.042-1.75l4.475,1.75a.838.838,0,0,0,1.074-.35l3.58-6.038a1.055,1.055,0,0,0-.179-1.137ZM20.83,27a6.127,6.127,0,1,1,0-12.25,6.127,6.127,0,1,1,0,12.25Z",
    transform: "translate(-3.375 -3.375)",
    fill: "#39beec"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIcon);
export default __webpack_public_path__ + "static/media/SettingsIcon.79590c3a82d927a377df7316d10b420a.svg";
export { ForwardRef as ReactComponent };